// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ActivityStatus } from './ActivityStatus'
import {
  ActivityStatusFromJSON,
  ActivityStatusFromJSONTyped,
  ActivityStatusToJSON,
} from './ActivityStatus'
import type { Role } from './Role'
import { RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from './Role'

/**
 *
 * @export
 * @interface ActivityRepresentation
 */
export interface ActivityRepresentation {
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  creatorNote?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  hiddenTags?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityRepresentation
   */
  learningTime?: number | null
  /**
   *
   * @type {ActivityStatus}
   * @memberof ActivityRepresentation
   */
  status?: ActivityStatus
  /**
   *
   * @type {Role}
   * @memberof ActivityRepresentation
   */
  creatorRole?: Role
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  createdBy?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  updatedBy?: string | null
  /**
   *
   * @type {Date}
   * @memberof ActivityRepresentation
   */
  createdDate?: Date
  /**
   *
   * @type {Date}
   * @memberof ActivityRepresentation
   */
  updatedDate?: Date | null
  /**
   *
   * @type {boolean}
   * @memberof ActivityRepresentation
   */
  isUserCreated?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ActivityRepresentation
   */
  isLocked?: boolean | null
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  originalActivityId?: string | null
  /**
   *
   * @type {boolean}
   * @memberof ActivityRepresentation
   */
  publishStatus?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ActivityRepresentation
   */
  isFeatured?: boolean | null
  /**
   *
   * @type {number}
   * @memberof ActivityRepresentation
   */
  targetWordCount?: number
  /**
   *
   * @type {number}
   * @memberof ActivityRepresentation
   */
  maxCoinAward?: number
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  activityId: string
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  description?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  thumbnail?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  template?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityRepresentation
   */
  tags?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityRepresentation
   */
  ranking?: number
}

/**
 * Check if a given object implements the ActivityRepresentation interface.
 */
export function instanceOfActivityRepresentation(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'activityId' in value

  return isInstance
}

export function ActivityRepresentationFromJSON(
  json: any,
): ActivityRepresentation {
  return ActivityRepresentationFromJSONTyped(json, false)
}

export function ActivityRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    creatorNote: !exists(json, 'creator_note')
      ? undefined
      : json['creator_note'],
    hiddenTags: !exists(json, 'hidden_tags') ? undefined : json['hidden_tags'],
    learningTime: !exists(json, 'learning_time')
      ? undefined
      : json['learning_time'],
    status: !exists(json, 'status')
      ? undefined
      : ActivityStatusFromJSON(json['status']),
    creatorRole: !exists(json, 'creator_role')
      ? undefined
      : RoleFromJSON(json['creator_role']),
    createdBy: !exists(json, 'created_by') ? undefined : json['created_by'],
    updatedBy: !exists(json, 'updated_by') ? undefined : json['updated_by'],
    createdDate: !exists(json, 'created_date')
      ? undefined
      : new Date(json['created_date']),
    updatedDate: !exists(json, 'updated_date')
      ? undefined
      : json['updated_date'] === null
        ? null
        : new Date(json['updated_date']),
    isUserCreated: !exists(json, 'is_user_created')
      ? undefined
      : json['is_user_created'],
    isLocked: !exists(json, 'is_locked') ? undefined : json['is_locked'],
    originalActivityId: !exists(json, 'original_activity_id')
      ? undefined
      : json['original_activity_id'],
    publishStatus: !exists(json, 'publish_status')
      ? undefined
      : json['publish_status'],
    isFeatured: !exists(json, 'is_featured') ? undefined : json['is_featured'],
    targetWordCount: !exists(json, 'target_word_count')
      ? undefined
      : json['target_word_count'],
    maxCoinAward: !exists(json, 'max_coin_award')
      ? undefined
      : json['max_coin_award'],
    activityId: json['activity_id'],
    title: !exists(json, 'title') ? undefined : json['title'],
    description: !exists(json, 'description') ? undefined : json['description'],
    thumbnail: !exists(json, 'thumbnail') ? undefined : json['thumbnail'],
    template: !exists(json, 'template') ? undefined : json['template'],
    tags: !exists(json, 'tags') ? undefined : json['tags'],
    ranking: !exists(json, 'ranking') ? undefined : json['ranking'],
  }
}

export function ActivityRepresentationToJSON(
  value?: ActivityRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    creator_note: value.creatorNote,
    hidden_tags: value.hiddenTags,
    learning_time: value.learningTime,
    status: ActivityStatusToJSON(value.status),
    creator_role: RoleToJSON(value.creatorRole),
    created_by: value.createdBy,
    updated_by: value.updatedBy,
    created_date:
      value.createdDate === undefined
        ? undefined
        : value.createdDate.toISOString(),
    updated_date:
      value.updatedDate === undefined
        ? undefined
        : value.updatedDate === null
          ? null
          : value.updatedDate.toISOString(),
    is_user_created: value.isUserCreated,
    is_locked: value.isLocked,
    original_activity_id: value.originalActivityId,
    publish_status: value.publishStatus,
    is_featured: value.isFeatured,
    target_word_count: value.targetWordCount,
    max_coin_award: value.maxCoinAward,
    activity_id: value.activityId,
    title: value.title,
    description: value.description,
    thumbnail: value.thumbnail,
    template: value.template,
    tags: value.tags,
    ranking: value.ranking,
  }
}
